import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isIE } from '../utils';

const USAGE_SUFFIX = /-usage$/;

const Icon = ({ className, title, glyph, rotating, customStyles, css }) => {
  const iconTitle = title
    ? `<title>${title}</title>`
    : '';

  let glyphId = glyph && (glyph.url || (glyph.id && `#${glyph.id}`) || glyph);

  // a hack to eliminate inconsitencies with sprite.svg from svg-sprite-loader
  if (USAGE_SUFFIX.test(glyphId)) {
    glyphId = glyphId.replace(USAGE_SUFFIX, '');
  }

  const link = {
    __html: `${iconTitle}<use xlink:href=${glyphId}></use>`,
  };


  // we should add rotating animation via css for IE and Edge because they do not support svg animation
  const rotatable = rotating && isIE();

  return (
    <svg
      className={classNames(className, { [css.main]: !customStyles, [css.rotating]: rotatable })}
      role="presentation"
      focusable="false"
      dangerouslySetInnerHTML={link}
    />
  );
};

Icon.propTypes = {
  glyph: PropTypes.object.isRequired,
  css: PropTypes.object.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  rotating: PropTypes.bool,
  customStyles: PropTypes.bool,
};

Icon.defaultProps = {
  className: '',
  title: '',
  rotating: false,
  customStyles: false,
};

export default Icon;
